import React from "react";
import { Helmet } from "react-helmet";

const WebDesign = () => {
  return (
    <>
      <Helmet>
        <title>Web Design & Development in Virar | Minexx</title>
        <meta
          name="description"
          content="Minexx offers high-converting web design and development services in Virar. Fast, modern, and SEO-friendly websites."
        />
      </Helmet>

      <section className="container pt-120">
        <h1>Web Design & Development in Virar</h1>
        <p>
          At Minexx, we build websites that don’t just look good — they perform.
          From business websites to landing pages, everything is designed to
          convert visitors into customers.
        </p>
      </section>
    </>
  );
};

export default WebDesign;